import Button from '@mui/material/Button';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form, { FormMessage } from '/@/components/form';
import Catalog from '/@/components/new-login/catalog';
import Container from '/@/components/new-login/container';
import settings from '/@/core/settings';
import { withRouter } from '/@/hooks/with-router';
import { _ } from '/@/locale';
import { confirmResetPassword, login } from '/@/store/session/actions';
import { isMobile, validateEmail, validatePassword } from '/@/utils';
import { reverse } from '/@/utils/router';
import Input from '/@/v3/components/forms/input';
import Title from '/@/v3/components/title';

import styles from './styles.module.css';

@connect(null, (dispatch) => bindActionCreators({ confirmResetPassword, login }, dispatch))
@withRouter
@autobind
export default class PasswordResetConfirm extends Form {
    static propTypes = {
        token: PropTypes.string.isRequired,
    };

    static contextTypes = {
        history: PropTypes.object,
    };

    state = {
        confirm: false,
        catalog: false,
    };

    fields = {
        email: { initial: '' },
        password: { initial: '' },
        confirmPassword: { initial: '' },
    };

    validation = {
        email: (values) => validateEmail(values.email),
        password: (values) => this.validatePassword(values.password),
        confirmPassword: (values) => validatePassword(values.confirmPassword, values.password),
    };

    handleLogin() {
        this.context.history(reverse('Login'));
    }

    async handleSubmit() {
        this.setState({ loading: true, error: '' });

        try {
            await this.props.confirmResetPassword({
                ...this.state.values,
                token: this.props.token,
            });
            this.setState({ confirm: true });
        } catch (error) {
            this.setState({ loading: false, error: error.message });
        }
    }

    validatePassword() {
        if (this.state.values.password.length > 4) {
            return true;
        }
        return;
    }

    renderChangePassword() {
        return (
            <div className={styles.root}>
                <div className={styles.successHeader}>
                    <div className={classNames(styles.logo, styles[`theme-${settings.app.theme}`])} />
                </div>
                <div className={styles.formContainer}>
                    <Title color='primary' bolder theme={settings.app.theme} className={styles.title}>
                        {this.state.confirm ? _('Genial!') : _('Recuperar contraseña')}
                    </Title>

                    {this.state.confirm ? (
                        <Title color='light' size='md' className={styles.confirmText}>
                            {_(
                                'Modificaste los datos de tu contraseña con éxito! Inicia sesión para poder ingresar nuevamente a la plataforma.'
                            )}
                        </Title>
                    ) : (
                        <div className={styles.form}>
                            <div>
                                <Input
                                    type='email'
                                    color={settings.app.theme}
                                    placeholder={_('E-mail')}
                                    {...this.getFieldProps('email')}
                                />
                            </div>

                            <div>
                                <Input
                                    iconPassword
                                    type='password'
                                    color={settings.app.theme}
                                    placeholder={_('Nueva contraseña')}
                                    {...this.getFieldProps('password')}
                                />

                                <div
                                    className={classNames(
                                        this.validatePassword() && styles.green,
                                        styles.verifyPassword
                                    )}
                                >
                                    {this.validatePassword() && (
                                        <span id={styles.check} className='material-icons'>
                                            done
                                        </span>
                                    )}
                                    <Title
                                        size='md'
                                        align='left'
                                        className={classNames(styles.text, this.validatePassword() && styles.green)}
                                    >
                                        {_('5 Caracteres')}
                                    </Title>
                                </div>
                            </div>
                            <div>
                                <Input
                                    iconPassword
                                    type='password'
                                    color={settings.app.theme}
                                    placeholder={_('Confirmar contraseña')}
                                    {...this.getFieldProps('confirmPassword')}
                                />
                            </div>

                            <FormMessage style='error'>{this.state.error}</FormMessage>
                        </div>
                    )}

                    <Button
                        variant='contained'
                        disabled={this.state.confirm ? false : this.state.loading || !this.validate()}
                        onClick={this.state.confirm ? this.handleLogin : this.handleSubmit}
                        fullWidth
                    >
                        {this.state.confirm
                            ? _('Iniciar sesión')
                            : this.state.loading
                              ? _('Guardando...')
                              : _('Guardar')}
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                {isMobile() ? (
                    this.renderChangePassword()
                ) : (
                    <Container showCatalog={() => this.setState({ catalog: true })} showLanguage={!this.state.confirm}>
                        {this.state.catalog ? (
                            <Catalog onClick={() => this.setState({ catalog: false })} />
                        ) : (
                            this.renderChangePassword()
                        )}
                    </Container>
                )}
            </Fragment>
        );
    }
}
